import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import type { Product } from '~/services/api.server';
import * as gtm from '~/utils/gtm.client';
import ProductCard from '../shared/ProductCard';

type relatedProductsProps = {
  products?: Product[];
};

export default function RelatedProducts({ products }: relatedProductsProps) {
  React.useEffect(() => {
    gtm.push_related_products(products || []);
  }, []);

  return products && products.length > 0 ? (
    <Stack direction="column" mt={8}>
      <Typography variant="h6" component="h2">
        You may also like
      </Typography>
      <Grid container spacing={3} sx={{ marginTop: 0 }}>
        {products.map((p) => {
          return (
            <Grid key={p.id} item display="grid" xs={12} sm={6} md={4} lg={3}>
              <ProductCard product={p} />
            </Grid>
          );
        })}
      </Grid>
    </Stack>
  ) : null;
}
